import { toggleItem } from '../../../../../State/selectedItems'

export default (guid) => (dispatch) => {

  dispatch(toggleItem(guid))

}
